/** External CSS */
import "./index.css"


export const LoadingIcon = () => {
    return (<div className="loading-container">

    </div>);
}